import { FC } from 'react';
import { EventProfileSummaryProps } from './EventProfileSummary.types';
import { StyledEventProfileSummary } from './EventProfileSummary.styles';
import { SummaryRow } from '../../../../molecules';
import { useRfpStore } from '../../../../store';
import { getFormattedDateString, isSameDay } from '../../../../utils';

export const EventProfileSummary: FC<EventProfileSummaryProps> = ({ labels }) => {
  const {
    eventLabel,
    eventDateLabel,
    eventDatesLabel,
    flexibleDatesLabel,
    eventTypeLabel,
    attendeesLabel,
    guestRoomsLabel,
  } = labels;

  const { eventProfileData } = useRfpStore();
  const { eventName, startDate, endDate, flexibleDates, eventType, otherEventType, attendees, guestRooms } =
    eventProfileData;
  const isSingleDayEvent = isSameDay(startDate, endDate);
  const dateLabel = isSingleDayEvent ? eventDateLabel : eventDatesLabel;
  const eventDatesValue = isSingleDayEvent
    ? getFormattedDateString(startDate, 'dateWithDayMonthAndYear')
    : `${getFormattedDateString(startDate, 'dateWithDayMonthAndYear')} - ${getFormattedDateString(
        endDate,
        'dateWithDayMonthAndYear'
      )}`;

  return (
    <StyledEventProfileSummary>
      {eventProfileData.eventName && <SummaryRow label={eventLabel} value={eventName} />}
      {eventProfileData.dates && <SummaryRow label={dateLabel} value={eventDatesValue} />}
      {flexibleDates.selected && flexibleDates.label === 'Yes' && <SummaryRow value={flexibleDatesLabel} />}
      {eventType.selected && <SummaryRow label={eventTypeLabel} value={otherEventType || eventType.label} />}
      {attendees && <SummaryRow label={attendeesLabel} value={attendees} />}
      {guestRooms && <SummaryRow label={guestRoomsLabel} value={guestRooms} />}
    </StyledEventProfileSummary>
  );
};
